<div class="backdrop" (click)="Decaf ? toggleDecafTotals() : toggleTotals()">
  @if (!Decaf) {
  <div class="popup-container" role="dialog" aria-modal="true" aria-label="Cost breakdown" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" tabindex="-1" (click)="$event.stopPropagation()">
    <div class="calc-header"><h2 style="color: #578587; margin-top:1px">Cost breakdown</h2></div>
    <fieldset class="rms-fieldset form-field popup"
              [ngClass]="{'shrinkOnHide': closingTotals}" style="gap: 70px;">
      <div style="display:flex; flex-direction:column; width:40%">
        <rms-input name="tc" class="form-field" type="currency" [noMargin]="true"
                   decimalFormat="1.4-4" [(ngModel)]="totalCost" label="Total Value" [disabled]="true"></rms-input>

        <rms-input name="sslp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="steamShipRatePerPound" suffix="per container" decimalFormat="1.4-4"
                   label="SSL" [disabled]="true"></rms-input>

        <rms-input name="mip" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="marineInsurancePerPound" suffix="per $100 value" decimalFormat="1.4-4"
                   label="Marine Insurance" [disabled]="true"></rms-input>

        <rms-input name="daep" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="dutyAndEntryPerPound" suffix="per entry" decimalFormat="1.4-4"
                   label="Duty And Entry" [disabled]="true"></rms-input>

        <rms-input name="drayagep" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="drayagePerPound" siffix="per container" decimalFormat="1.4-4"
                   label="Drayage" [disabled]="true"></rms-input>

        <rms-input name="strippingp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="strippingPerPound" suffix="per bag" decimalFormat="1.4-4"
                   label="Stripping" [disabled]="true"></rms-input>

        <rms-input name="storagep" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="storagePerPound" suffix="per bag" decimalFormat="1.4-4"
                   label="Storage" [disabled]="true"></rms-input>

        <rms-input name="weighingp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="weighingPerPound" suffix="per bag" decimalFormat="1.4-4"
                   label="Weighing" [disabled]="true"></rms-input>

        <rms-input name="finp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="financingPerPound" [suffix]="'% per '+ DaysToFinance +' days'"
                   decimalFormat="1.4-4" label="Financing" [disabled]="true"></rms-input>

        <rms-input name="fotp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="fot" decimalFormat="1.4-4" label="FOT" [disabled]="true"></rms-input>

        <rms-input name="samplechargep" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="sampleCharge" decimalFormat="1.4-4" label="Sample Charge" [disabled]="true"></rms-input>

        <rms-input name="rfap" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="rfa" decimalFormat="1.4-4" label="RFA" [disabled]="true"></rms-input>

        <rms-input name="totest" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="totalEstimate" decimalFormat="1.4-4"
                   label="Total Estimated Cost" [disabled]="true"></rms-input>

        <rms-input name="fcw" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="finalCostWith" decimalFormat="1.4-4" label="RNY Buffer"
                   (ngModelChange)="recalculateCostsDebounced()"></rms-input>

        <rms-input name="rb" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="rateBuffer" decimalFormat="1.4-4" label="SSL Rate Buffer"
                   (ngModelChange)="recalculateCostsDebounced()"></rms-input>

        <rms-input name="fobexp"
                   class="form-field"
                   type="currency"
                   [noMargin]="true"
                   [ngModel]="usedHandlingCost"
                   decimalFormat="1.4-4"
                   [label]="usedHandlingLabel"
                   [disabled]="true">
        </rms-input>
      </div>

      <div style="display:flex; flex-direction:column; width:40%">
        <rms-input name="wt" class="form-field" type="decimal" [noMargin]="true"
                   [(ngModel)]="netWeight" decimalFormat="1.4-4" label="Total Weight" [disabled]="true"></rms-input>

        <rms-input [backgroundColor]="WorstCase ? 'rgba(255, 59, 48, 0.24)' : '#19b238'"
                   name="ssl" class="form-field" type="currency" [noMargin]="true" decimalFormat="1.4-4"
                   [(ngModel)]="steamShipRate" label="SSL" (ngModelChange)="recalculateCostsDebounced()"></rms-input>

        <rms-input name="mi" class="form-field" type="percent" [noMargin]="true" decimalFormat="1.4-4"
                   [(ngModel)]="marineInsurance" label="Marine Insurance" (ngModelChange)="recalculateCostsDebounced()"></rms-input>

        <rms-input name="dae" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="dutyAndEntry" decimalFormat="1.4-4" label="Duty And Entry" [disabled]="true"></rms-input>

        <rms-input name="dray" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="drayage" decimalFormat="1.4-4" label="Drayage" [disabled]="true"></rms-input>

        <rms-input name="stripping" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="stripping" decimalFormat="1.4-4" label="Stripping" [disabled]="true"></rms-input>

        <rms-input name="storage" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="storage" decimalFormat="1.4-4" label="Storage" [disabled]="true"></rms-input>

        <rms-input name="weighing" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="weighing" decimalFormat="1.4-4" label="Weighing" [disabled]="true"></rms-input>

        <rms-input name="financing" class="form-field" type="percent" [noMargin]="true"
                   [(ngModel)]="financing" decimalFormat="1.4-4" label="Financing" [disabled]="true"></rms-input>

        <rms-input name="fot" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="fot" decimalFormat="1.4-4" label="FOT" (ngModelChange)="recalculateCostsDebounced()"></rms-input>

        <rms-input name="samplecharge" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="sampleCharge" decimalFormat="1.4-4" label="Sample Charge" [disabled]="true"></rms-input>

        <rms-input name="rfa" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="rfa" decimalFormat="1.4-4" label="RFA" (ngModelChange)="recalculateCostsDebounced()"></rms-input>

        <rms-input name="tcomm" class="form-field" type="currency" [noMargin]="true"
                   [ngModel]="0" decimalFormat="1.4-4" label="Total Commissions" [disabled]="true"></rms-input>

        <rms-select name="dtf" class="form-field"
                    [options]="DaysToFinanceList" labelKey="name" valueKey="value"
                    [(ngModel)]="DaysToFinance" label="Days To Finance"
                    (ngModelChange)="recalculateCostsDebounced()"></rms-select>

        <br />
        <div class="calc-actions"><button class="btn-bg-red" type="button" mat-button (click)="cancel()">Cancel</button><button type="button" mat-flat-button class="btn-bg-green" (click)="apply()">Apply costs</button></div>
      </div>
    </fieldset>
  </div>
  } @else {
  <div class="popup-container" role="dialog" aria-modal="true" aria-label="Cost breakdown" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" tabindex="-1" (click)="$event.stopPropagation()">
    <div class="calc-header"><h2 style="color: #578587; margin-top:1px">Decaf Calculations</h2></div>
    <fieldset class="rms-fieldset form-field popup"
              [ngClass]="{'shrinkOnHide': closingTotals}" style="gap: 70px;">
      <div style="display:flex; flex-direction:column; width:40%">
        <rms-input name="tdc" class="form-field" type="decimal" [noMargin]="true"
                   decimalFormat="1.4-4" [(ngModel)]="totalDecafNetWeight"
                   label="Weight After Decaf" [disabled]="true"></rms-input>

        <rms-input name="dsslp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="DecafCostPerPound" suffix="per pound" decimalFormat="1.4-4"
                   label="Decaffeinator Cost" (ngModelChange)="recalculateDecafCostsDebounced()"></rms-input>

        <rms-input name="dstrippingp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafStrippingPerBag" suffix="per bag" decimalFormat="1.4-4"
                   label="Stripping" (ngModelChange)="recalculateDecafCostsDebounced()"></rms-input>

        <rms-input name="dstoragep" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafStoragePerBag" suffix="per bag" decimalFormat="1.4-4"
                   label="Storage" (ngModelChange)="recalculateDecafCostsDebounced()"></rms-input>

        <rms-input name="dweighingp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafWeighingPerBag" suffix="per bag" decimalFormat="1.4-4"
                   label="Weighing" (ngModelChange)="recalculateDecafCostsDebounced()"></rms-input>

        <rms-input name="dfinp" class="form-field" type="percent" [noMargin]="true"
                   [(ngModel)]="decafFinancingPercent" [suffix]="'% per 120 days'"
                   decimalFormat="1.4-4" label="Financing" [disabled]="true"></rms-input>

        <rms-input name="dtotest" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafTolling" decimalFormat="1.4-4"
                   label="Total Estimated Cost" [disabled]="true"></rms-input>

        <rms-input name="dfcw" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafBuffer" decimalFormat="1.4-4" label="Buffer"
                   (ngModelChange)="recalculateDecafCostsDebounced()"></rms-input>

        <rms-input name="dfobexp" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafTollingPerPound" decimalFormat="1.4-4"
                   label="Final Estimated Cost" [disabled]="true"></rms-input>
      </div>
      <div style="display:flex; flex-direction:column; width:40%">
        <rms-input name="dwt" class="form-field" type="decimal" [noMargin]="true"
                   [(ngModel)]="totalDecafNetWeightFromLoss" decimalFormat="1.4-4"
                   label="Total Weight Loss" [disabled]="true"></rms-input>

        <rms-input name="dssl" class="form-field" type="currency" [noMargin]="true"
                   decimalFormat="1.4-4" [(ngModel)]="DecafCostTotal"
                   label="Decaffeinator Cost" [disabled]="true"></rms-input>

        <rms-input name="ddray" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafStripping" decimalFormat="1.4-4"
                   label="Stripping" [disabled]="true"></rms-input>

        <rms-input name="dstorage" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafStorage" decimalFormat="1.4-4" label="Storage" [disabled]="true"></rms-input>

        <rms-input name="dweighing" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafWeighing" decimalFormat="1.4-4" label="Weighing" [disabled]="true"></rms-input>

        <rms-input name="dfinancing" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafFinancing" decimalFormat="1.4-4" label="Financing" [disabled]="true"></rms-input>

        <rms-input name="dlov" class="form-field" type="currency" [noMargin]="true"
                   [(ngModel)]="decafLossValue" decimalFormat="1.4-4" label="Loss Of Value" [disabled]="true"></rms-input>

        <rms-input name="dtruck" class="form-field" type="currency" [noMargin]="true"
                   decimalFormat="1.4-4" [(ngModel)]="decafTrucking" label="Trucking"
                   (ngModelChange)="recalculateDecafCostsDebounced()"></rms-input>

        <rms-input *ngIf="DecaffeinatorID == 6815" name="dsea" class="form-field"
                   type="currency" [noMargin]="true" [(ngModel)]="decafSeaforth"
                   decimalFormat="1.4-4" label="Seaforth" [disabled]="true"></rms-input>

        <br />
        <div class="calc-actions"><button class="btn-bg-red" type="button" mat-button (click)="cancel()">Cancel</button><button type="button" mat-flat-button class="btn-bg-green" (click)="apply()">Apply costs</button></div>
      </div>

    </fieldset>
  </div>
  }
</div>
